<template>
    <div :class="['header-model', isNavigat ? 'isHeaderShow' : isChildeNavigat ? 'header-bg-model' : '']">
        <div :class="['header-content',isMobile ? 'isHeaderLogo' : '']">
            <router-link to="/recommendList" v-if="!isChildeNavigat" @click.native="handleClick"><img src="../assets/images/logo.png"></router-link>
            <!-- width: 162px -->
            <router-link to="/recommendList" v-if="isChildeNavigat" @click.native="handleClick"><img src="../assets/images/logo_bg.png" ></router-link>
            <div class="menu-navigat">
                <i :class="[ismenu ? 'el-icon-close icon-close-color' : 'el-icon-s-fold','menu-fold']" @click="handelChageMenu"></i>
                <div :class="['menu-list', ismenu ? 'menu-fixed' : '']">
                    <ul :class="[isMobile ? 'isIpadMenu' : '']">
                        <li><router-link to="/about">
                            <span>ABOUT</span>
                            <span style="margin-left: 3px;">简介</span>
                        </router-link></li>
                        <li><router-link to="/projectList" @click.native="handleClickPrject">
                            <span>PROJECTS</span>
                            <span style="margin-left: 3px;">项目</span>
                        </router-link></li>
                        <li><router-link to="/newsList" @click.native="handleClickNew">
                            <span>EVENTS</span>
                            <span style="margin-left: 3px;">事件</span>
                        </router-link></li>
                        <li><router-link to="/contect">
                            <span>CONTACT</span>
                            <span style="margin-left: 3px;">联系</span>
                        </router-link></li>
                    </ul>
                </div>
            </div>
            
        </div>

        <!-- <div style="cursor: pointer;" v-if="isUnfold == 4 && isChildeNavigat && isNavigat" @click="handelUnfold"><i class="el-icon-s-unfold" style="font-size: 28px;margin: 10px;"></i></div> -->
    </div>
</template>

<script>
// import {getProjectCategory} from '@/api/axios-api'
export default {
    name: 'Header',
    props: {
        videoHeight: Number,
        isScroll: Number,
        iseNavigat:Boolean,
        isPic: Number,
        isMobile: Boolean,
    },
    
    data () {
        return {
            isNavigat: false,
            isChildeNavigat: false,
            ismenu: false,
            videoHeightNew: 0,
            oldScrollTop: 0,
            isnewScroll: 0,
            isUnfold: 0,
            isNewPic: this.isPic,
            // isMobile: false,

        }
    },
    created () {
        // alert(this.isMobile)
        // const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        
        // if (userAgent) {
        //     // alert(userAgent)
        //     this.isMobile = true
        // }
        
        // alert(this.isNewPic)

    },
    
    mounted () {
        
        // alert(this.isScroll)
        window.addEventListener('scroll', this.handleScroll,true)
        // alert(this.isChildeNavigat)
        
        this.isChildeNavigat = this.iseNavigat
        this.isnewScroll = this.isScroll

        this.isUnfold = this.isScroll
        // alert(this.isScroll)

        // console.log(this.isChildeNavigat)
        
    },
    watch: {
        // isPic (newIsPic) {
        //     this.isNewPic = newIsPic
        //     // alert(this.isNewPic)
        // },
        videoHeight (newData) {
            this.$nextTick(() => {
                this.videoHeightNew = newData
                // alert(this.videoHeightNew)
                // alert(this.videoHeightNew)
            })
        },
        // iseNavigat (newData) {
        //     console.log(newData)
        //     // alert(newData)
        // }

    },
    methods: {

        handleClick (event) {
            // alert(this.$route.name)
            sessionStorage.removeItem('projectList')
            sessionStorage.removeItem('isCache')
            sessionStorage.removeItem('videolist')

            sessionStorage.removeItem('RecomListData')
            sessionStorage.removeItem('isRecomListCache')

            

            if (this.$route.name === 'RecommendList') {
                event.preventDefault()
                window.location.reload()  
            }
        },

        handleClickPrject (event) {
            sessionStorage.removeItem('ProjectListData')
            sessionStorage.removeItem('isProjectListCache')
            if (this.$route.name === 'ProjectList') {
                event.preventDefault()
                window.location.reload()
            }
            
        },

        handleClickNew (event) {
            sessionStorage.removeItem('ProjectListData')
            sessionStorage.removeItem('isProjectListCache')
            if (this.$route.name === 'NewsList') {
                event.preventDefault()
                window.location.reload()
            }
        },

        handleRefresh() {
            // event.preventDefault();
            sessionStorage.removeItem('projectList')
            sessionStorage.removeItem('isCache')
            sessionStorage.removeItem('videolist')

            sessionStorage.removeItem('RecomListData')
            sessionStorage.removeItem('isRecomListCache')

            sessionStorage.removeItem('ProjectListData')
            sessionStorage.removeItem('isProjectListCache')

            window.location.reload()
        },

        handelUnfold () {
            this.isNavigat = !this.isNavigat
        },

        // 切换显示菜单
        handelChageMenu () {
            this.ismenu = !this.ismenu
            if (this.ismenu) {
                this.isChildeNavigat = true
            } else {
                this.isChildeNavigat = false
            }
        },

        handleScroll () {
            // alert(this.isnewScroll)
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop
            let scrollStep = scrollTop - this.oldScrollTop
            this.oldScrollTop = scrollTop
            // console.log(scrollTop)

            if (scrollStep < 0) {
                // 执行向上滚动逻辑（如隐藏组件、调整高度）
                // alert('向上')
                if (JSON.parse(scrollTop) < JSON.parse(this.videoHeightNew - 100)) {
                    this.isNavigat = false
                    this.isChildeNavigat = false
                } else {
                    // console.log(scrollStep)
                    
                    // alert(this.isnewScroll)
                    // // alert(this.isScroll)
                    if (this.isScroll != 4) {
                        // if (this.isNewPic == 1) {
                            this.isNavigat = false
                            this.isChildeNavigat = true
                            
                        // }
                        
                    } else {
                       
                        if (scrollTop == 0) {
                            this.isNavigat = false
                            this.isChildeNavigat = true
                        }
                    }
                    
                }
               
            } else {
                // alert('向下')
                // 执行向上滚动逻辑（如隐藏组件、调整高度）
                if (scrollTop > this.videoHeightNew - 100) {

                    // console.log(this.isScroll)
                    if (this.isnewScroll == 3) {
                        this.isNavigat = false
                        // this.isChildeNavigat = true
                    } else {
                        // alert('12121')
                        this.isNavigat = true
                        // this.isChildeNavigat = true
                    }

                    
                    if (this.isnewScroll != 4) {
                        // alert(this.isnewScroll)
                        this.isnewScroll = 1 // 初始化导航显示问题
                        // this.isChildeNavigat = true
                        
                    } else {
                        this.isNavigat = false
                        // this.isChildeNavigat = true
                        
                    }
                }
            }

            
        }
    }
}
</script>

<style scoped lang="scss">
.header-model {
    width: 100%;
    height: 6.25rem;
    // height: 100px;
    position: fixed;
    z-index: 99;
    transition: top 0.5s ease;
}
.menu-fold {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
    display: none;
}
.header-bg-model {
    background: #fff;
    // border-bottom: 1px solid #E5E6E6;
    box-sizing: border-box;
    top: 0;
}
.header-model .header-content {
    width: calc(100% - 66px);
    margin: auto;
    // transform: translateX(-50%);
    height: 6.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header-model .header-content img {
    width: 10.1875rem;
}
.isHeaderShow {
    top: -6.25rem;
}
.header-model .menu-navigat {
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    // margin-top: 2.3125px;
}
.header-model .menu-fixed {
    background: #fff;
    position: fixed;
    left: 0;
    top: 70px;
    bottom: 0;
    width: 100%;
}

.header-model .menu-navigat .menu-list.menu-fixed {
    display: flex;
    transform: translateX(0); /* 从右向左移动 */
    transition: transform 2s ease; /* 添加过渡效果 */
    padding: 0 3%;
}

.header-model .menu-navigat .menu-fixed .menu-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.header-model .menu-navigat .menu-fixed .menu-list li{
    padding: 15px 0;
}
.header-model .menu-navigat ul {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.header-model .menu-navigat .menu-list.menu-fixed ul {
    flex-direction: column;
    align-items: flex-start;
}
.header-model .menu-navigat ul.menu-list {
    display: flex;
    // transform: translateX(0); /* 从右向左移动 */
}
.header-model .menu-navigat li {
    // float: left;
    // margin-left: 15px;
    padding: 0 8px;
    // width: 130px;
    text-align: center;
    // height: 20px;
    // line-height: 20px;
    // background: red;
    
}
.header-model .menu-navigat .menu-list.menu-fixed li {
    // padding: 10px 0;
    // width: 130px;
    // background: red;
}
.header-model .menu-navigat li a {
    color: #fff;
    font-size: 1.5rem;
    font-weight: 700;
    // height: 20px;
    // line-height: 20px;
    font-family: "ahronbd";
    position: relative;
    
    
}
.header-model .menu-navigat li a span:nth-child(1) {
    // position: relative;
    // background: #fff;
    // z-index: 99;
    display: inline-block;
    height: 1.25rem;
    line-height: 23px;
}
.header-model .menu-navigat li a span:nth-child(2) {
    // display: none;
    font-family: 'SourceHanSans';
    font-size: 1.125rem;
    
}
.header-bg-model .menu-navigat li a {
    display: flex;
    color: #545454;
    align-items: center;
    height: 1.25rem;
    line-height: 20px;
    position: relative;
    
}
.header-model .menu-navigat li a span:nth-child(1) {
    position: relative;
    // background: #fff;
    z-index: 99;
}
.header-model .menu-navigat li a span:nth-child(2) {
    display: inline-block;
    height: 1.25rem;
    line-height: 18px;
    // width: 100%;
    // position: absolute;
    // top: 0px;
    // left: 0;
    // text-align: center;
    // color: #545454;
    // // background: #fff;
    // transition: top 0.5s ease;
    // // z-index: 4;
    // opacity: 0;
}
// .header-model .menu-navigat li a:hover span:nth-child(2) {
//     // display: inline-block;
//     opacity: 1;
//     top: -29px;
// }
.header-model .menu-navigat li a:hover {
    color: #000;
}
.icon-close-color {
    color: #000;
}

// @keyframes moveDown {
//   from {
//     // opacity: 0;
//     top: 0; /* 起始位置 */
//   }
//   to {
//     opacity: 1;
//     top: 23px; /* 结束位置 */
//   }
// }

@media (max-width: 768px) {
    .header-model .header-content {
        width: calc(100% - 66px)
    }
    .menu-fold {
        display: block;
    }
    .header-model .menu-navigat .menu-list {
        display: none;
        transform: translateX(100%); /* 从右向左移动 */
        transition: transform 2s ease; /* 添加过渡效果 */
    }
}


@media only screen and (min-width: 2048px) {
    .header-model .menu-navigat {
        margin-top: 55px;
    }
    .header-model .menu-navigat li a {
        font-size: 1.47rem;
    }
  .header-model .menu-navigat li a span:nth-child(2) {
    font-size: 1.125rem;
  }
}

@media only screen and (min-width: 2560px) {
    .header-model .menu-navigat {
        margin-top: 65px;
    }
    .header-model .menu-navigat li a {
        font-size: 1.52rem;
    }
    .header-model .menu-navigat li a span:nth-child(2) {
        font-size: 1.15rem;
    }
}
@media (min-width: 1536px) and (max-width: 1708px) {
    .header-model .menu-navigat li a {
        font-size: 1.4rem;
    }
    .header-model .menu-navigat li a span:nth-child(2) {
        font-size: 1.15rem;
    }
}

@media (min-width: 1463px) and (max-width: 1536px) {
    .header-model .menu-navigat li a {
        font-size: 1.35rem;
    }
    .header-model .menu-navigat li a span:nth-child(2) {
        // display: none;
        font-size: 1.125rem;
    }
}

@media (min-width: 1360px) and (max-width: 1463px) {
    .header-model .menu-navigat li a {
        font-size: 1.8rem;
    }
    .header-model .menu-navigat li a span:nth-child(2) {
        // display: none;
        font-size: 1.5rem;
    }
}



@media only screen and (max-width: 1280px) {
    .header-model .header-content img {
        width: 9.1875rem;
    }
    .header-model .menu-navigat {
        margin-top: 11px;
    }
    .header-model .menu-navigat li a {
        font-size: 1.7rem;
        // color: red;
    }
    .header-model .menu-navigat li a span:nth-child(2) {
        font-size: 1.255rem;
    }
    .header-model .menu-navigat li a span:nth-child(1) {
        line-height: 20px;
    }
}

// ipad 样式
// .header-model .menu-navigat .isIpadMenu li a {
//     font-size: 2.125rem;
// }
// .header-model .isHeaderLogo img {
//     width: 12rem;
//     margin-top: 10px;
// }
// .header-model .menu-navigat .isIpadMenu li a span:nth-child(2) {
//     font-size: 1.9rem;
// }
</style>